<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog';
    

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class NumericInputDialog extends Vue
    {
        get vm(): NumericInputDialogViewModel { return this.$props.viewModel as NumericInputDialogViewModel; }
        get opened(): boolean { return this.vm?.isOpened; }

        handleFormSubmit()
        {
            const value = this.vm.value?.toString().trim() || null;
            this.$emit('update-value', value, this.vm.id);
        }

        close()
        {
            this.vm.isOpened = false;
        }
    }

</script>

<template>      
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{vm.title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <form id="numeric-input-dialog-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>{{vm.label}} <span v-if="vm.showValueRange" class="text-muted">(from: {{ vm.minValue != null ? vm.minValue.toString() : 'any'  }}, to: {{ vm.maxValue != null ? vm.maxValue.toString() : 'any'  }})</span></label>
                                <input type="number" class="form-control" v-model.number="vm.value" :min="vm.minValue" :max="vm.maxValue" :step="vm.step" :required="vm.valueRequired" />
                                <small>{{vm.description}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="numeric-input-dialog-form" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>


</style>